import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import logo from "../assets/images/logo.png";
import { menuData } from "../data/header";
import SymbolSearchDialog from "../components/SymbolSearchDialog";
import PSXTicker from "../components/PSXTicker";

const OPEN_ACCOUNT = {
  cdc: "https://www.asaanconnect.com/cdc/cgp/r/centralized-gateway-portal/home",
  orbit: "https://www.aof.com.pk/?MTg2MjgyNTQzNzY0OTc5MjI4MzQyODYyNTI1NDY4NjQ4NDYyNzcyNw==",
};

function HeaderNavigation() {
  const location = useLocation();
  const history = useHistory();
  const [searchOpen, setSearchOpen] = useState(false);
  const [oaOpen, setOaOpen] = useState(false);
  const oaRef = useRef(null);

  const handleSymbolSelect = (item) => {
    history.push(`/trading-dashboard/${item.code}`);
  };

  // close "Open Account" dropdown on outside click
  useEffect(() => {
    const handle = (e) => {
      if (oaRef.current && !oaRef.current.contains(e.target)) setOaOpen(false);
    };
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, []);

  return (
    <>
      {/* ══ BAND 0: Live ticker strip (unchanged, dark) ══ */}
      <div className="hdr-ticker-band">
        <PSXTicker />
      </div>

      {/* ══ BAND 1: Logo + Nav + Search + Open Account (single white row) ══ */}
      <div className="hdr-nav-band">
        <div className="hdr-nav-inner">
          <Navbar expand="lg" className="hdr-navbar">

            {/* Logo */}
            <a href="/" className="hdr-logo-link">
              <img src={logo} alt="Orbit Securities" className="hdr-logo" />
            </a>

            <Navbar.Toggle aria-controls="hdr-nav-collapse" className="hdr-toggler" />

            <Navbar.Collapse id="hdr-nav-collapse" className="hdr-collapse">
              {/* Nav menu */}
              <Nav className="hdr-nav-links">
                {menuData.map((menu, index) => {
                  const isActive = menu.items.some(item => location?.pathname === item.link);
                  return (
                    <NavDropdown
                      key={index}
                      className="hdr-dropdown"
                      title={
                        <span className={`hdr-nav-title${isActive ? " hdr-nav-active" : ""}`}>
                          {menu.title}
                        </span>
                      }
                      id={`hdr-dd-${index}`}
                    >
                      {menu.items.map((item, i) => (
                        <NavDropdown.Item
                          key={i}
                          as={NavLink}
                          to={item.link}
                          className={({ isActive }) =>
                            `hdr-dd-item${isActive ? " hdr-dd-active" : ""}`
                          }
                        >
                          {item.label}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>
                  );
                })}
              </Nav>

              {/* Right actions: search + open account */}
              <div className="hdr-actions">
                <button
                  className="hdr-search-icon"
                  onClick={() => setSearchOpen(true)}
                  aria-label="Search stock symbols"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2.2"
                    strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                </button>

                <div className="hdr-oa" ref={oaRef}>
                  <button
                    className="hdr-oa-btn"
                    onClick={() => setOaOpen(o => !o)}
                    aria-expanded={oaOpen}
                  >
                    Open Account
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"
                      style={{ transform: oaOpen ? "rotate(180deg)" : "none", transition: "transform .15s" }}>
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </button>
                  {oaOpen && (
                    <div className="hdr-oa-menu">
                      <a href={OPEN_ACCOUNT.cdc} target="_blank" rel="noopener noreferrer" className="hdr-oa-item" onClick={() => setOaOpen(false)}>
                        Via CDC
                      </a>
                      <a href={OPEN_ACCOUNT.orbit} target="_blank" rel="noopener noreferrer" className="hdr-oa-item" onClick={() => setOaOpen(false)}>
                        Via Orbit
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>

      <SymbolSearchDialog
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
        onSelect={handleSymbolSelect}
      />
    </>
  );
}

export default HeaderNavigation;
